/** GENERATED by tools/canvas2jsx.py — the artboard icon sprite, verbatim. Render once per page; pass `only` for the symbols a page uses. */
import { Fragment, type CSSProperties, type ReactNode } from 'react'

export const SPRITE_IDS = ["i-check", "i-bolt", "i-search", "i-chev", "i-chev-d", "i-pin", "i-heart", "i-compare", "i-user", "i-leaf", "i-tag", "i-clock", "i-chart", "i-shield", "i-award", "i-snow", "i-ruler", "i-book", "i-wine", "i-home", "i-cpu", "i-vol", "i-build", "i-drop", "i-max", "i-min", "i-ribbon", "i-globe", "i-flag", "i-menu", "i-chat", "s-down", "s-down2", "s-down3"] as const
export type SpriteId = (typeof SPRITE_IDS)[number]

/** Every artboard symbol, keyed by id, in artboard order. */
export const SPRITE_SYMBOLS: ReadonlyArray<readonly [SpriteId, ReactNode]> = [
  ["i-check", (
    <symbol key="i-check" id="i-check" viewBox="0 0 24 24">
    <path d="M4 12.5l5 5L20 6.5" fill="none" stroke="#10a65c" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </symbol>
  )],
  ["i-bolt", (
    <symbol key="i-bolt" id="i-bolt" viewBox="0 0 24 24">
    <path d="M13 2L4 14h6l-1 8 9-12h-6l1-8z" fill="#ffd166" />
    </symbol>
  )],
  ["i-search", (
    <symbol key="i-search" id="i-search" viewBox="0 0 24 24">
    <circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" strokeWidth="2" />
    <path d="M16.5 16.5L21 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </symbol>
  )],
  ["i-chev", (
    <symbol key="i-chev" id="i-chev" viewBox="0 0 24 24">
    <path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </symbol>
  )],
  ["i-chev-d", (
    <symbol key="i-chev-d" id="i-chev-d" viewBox="0 0 24 24">
    <path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </symbol>
  )],
  ["i-pin", (
    <symbol key="i-pin" id="i-pin" viewBox="0 0 24 24">
    <path d="M12 21s-7-6.1-7-11a7 7 0 1114 0c0 4.9-7 11-7 11z" fill="none" stroke="currentColor" strokeWidth="2" />
    <circle cx="12" cy="10" r="2.6" fill="none" stroke="currentColor" strokeWidth="2" />
    </symbol>
  )],
  ["i-heart", (
    <symbol key="i-heart" id="i-heart" viewBox="0 0 24 24">
    <path d="M12 20.5S4 15 4 9.6A4.4 4.4 0 0112 6a4.4 4.4 0 018 3.6C20 15 12 20.5 12 20.5z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    </symbol>
  )],
  ["i-compare", (
    <symbol key="i-compare" id="i-compare" viewBox="0 0 24 24">
    <path d="M7 4v13M7 17l-3-3M7 17l3-3M17 20V7M17 7l-3 3M17 7l3 3" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </symbol>
  )],
  ["i-user", (
    <symbol key="i-user" id="i-user" viewBox="0 0 24 24">
    <circle cx="12" cy="8" r="4" fill="none" stroke="currentColor" strokeWidth="2" />
    <path d="M4 20c1.5-3.5 4.5-5 8-5s6.5 1.5 8 5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </symbol>
  )],
  ["i-leaf", (
    <symbol key="i-leaf" id="i-leaf" viewBox="0 0 24 24">
    <path d="M5 19C5 9 12 4 20 4c0 9-5 15-13 15" fill="none" stroke="#10a65c" strokeWidth="2" strokeLinejoin="round" />
    <path d="M5 19c3-4 7-7 10-8" fill="none" stroke="#10a65c" strokeWidth="2" strokeLinecap="round" />
    </symbol>
  )],
  ["i-tag", (
    <symbol key="i-tag" id="i-tag" viewBox="0 0 24 24">
    <path d="M3 11V3h8l10 10-8 8L3 11z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <circle cx="8" cy="8" r="1.6" fill="currentColor" />
    </symbol>
  )],
  ["i-clock", (
    <symbol key="i-clock" id="i-clock" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2" />
    <path d="M12 7v5l3.5 2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </symbol>
  )],
  ["i-chart", (
    <symbol key="i-chart" id="i-chart" viewBox="0 0 24 24">
    <path d="M4 19h16M6 16l4-5 3 3 5-7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </symbol>
  )],
  ["i-shield", (
    <symbol key="i-shield" id="i-shield" viewBox="0 0 24 24">
    <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <path d="M8.5 12l2.4 2.4L15.5 9.8" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </symbol>
  )],
  ["i-award", (
    <symbol key="i-award" id="i-award" viewBox="0 0 24 24">
    <circle cx="12" cy="9" r="6" fill="none" stroke="currentColor" strokeWidth="2" />
    <path d="M8.5 14L7 22l5-3 5 3-1.5-8" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    </symbol>
  )],
  ["i-snow", (
    <symbol key="i-snow" id="i-snow" viewBox="0 0 24 24">
    <path d="M12 2v20M4 6l16 12M20 6L4 18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </symbol>
  )],
  ["i-ruler", (
    <symbol key="i-ruler" id="i-ruler" viewBox="0 0 24 24">
    <rect x="3" y="9" width="18" height="6" rx="1" fill="none" stroke="currentColor" strokeWidth="2" />
    <path d="M7 9v3M11 9v3M15 9v3M19 9v3" stroke="currentColor" strokeWidth="2" />
    </symbol>
  )],
  ["i-book", (
    <symbol key="i-book" id="i-book" viewBox="0 0 24 24">
    <path d="M4 5a2 2 0 012-2h14v18H6a2 2 0 00-2 2V5z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <path d="M20 17H6a2 2 0 00-2 2" fill="none" stroke="currentColor" strokeWidth="2" />
    </symbol>
  )],
  ["i-wine", (
    <symbol key="i-wine" id="i-wine" viewBox="0 0 24 24">
    <path d="M8 3h8l-1 7a3 3 0 01-6 0L8 3zM12 13v7M8 21h8" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </symbol>
  )],
  ["i-home", (
    <symbol key="i-home" id="i-home" viewBox="0 0 24 24">
    <path d="M4 11l8-7 8 7v9a1 1 0 01-1 1h-5v-6h-4v6H5a1 1 0 01-1-1v-9z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    </symbol>
  )],
  ["i-cpu", (
    <symbol key="i-cpu" id="i-cpu" viewBox="0 0 24 24">
    <rect x="6" y="6" width="12" height="12" rx="2" fill="none" stroke="currentColor" strokeWidth="2" />
    <path d="M9 2v4M15 2v4M9 18v4M15 18v4M2 9h4M2 15h4M18 9h4M18 15h4" stroke="currentColor" strokeWidth="2" />
    </symbol>
  )],
  ["i-vol", (
    <symbol key="i-vol" id="i-vol" viewBox="0 0 24 24">
    <path d="M4 9v6h4l5 4V5L8 9H4z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <path d="M16 9a4 4 0 010 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </symbol>
  )],
  ["i-build", (
    <symbol key="i-build" id="i-build" viewBox="0 0 24 24">
    <rect x="4" y="3" width="16" height="18" rx="1" fill="none" stroke="currentColor" strokeWidth="2" />
    <path d="M8 7h2M14 7h2M8 11h2M14 11h2M8 15h2M14 15h2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </symbol>
  )],
  ["i-drop", (
    <symbol key="i-drop" id="i-drop" viewBox="0 0 24 24">
    <path d="M12 3s6 6.5 6 11a6 6 0 01-12 0c0-4.5 6-11 6-11z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    </symbol>
  )],
  ["i-max", (
    <symbol key="i-max" id="i-max" viewBox="0 0 24 24">
    <path d="M4 9V4h5M20 15v5h-5M4 4l6 6M20 20l-6-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </symbol>
  )],
  ["i-min", (
    <symbol key="i-min" id="i-min" viewBox="0 0 24 24">
    <path d="M10 4H4v6M14 20h6v-6M4 4l6 6M20 20l-6-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </symbol>
  )],
  ["i-ribbon", (
    <symbol key="i-ribbon" id="i-ribbon" viewBox="0 0 24 24">
    <path d="M6 3h12v18l-6-4-6 4V3z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    </symbol>
  )],
  ["i-globe", (
    <symbol key="i-globe" id="i-globe" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2" />
    <path d="M3 12h18M12 3c2.6 2.6 3.9 5.6 3.9 9S14.6 18.4 12 21c-2.6-2.6-3.9-5.6-3.9-9S9.4 5.6 12 3z" fill="none" stroke="currentColor" strokeWidth="2" />
    </symbol>
  )],
  ["i-flag", (
    <symbol key="i-flag" id="i-flag" viewBox="0 0 24 24">
    <path d="M5 21V4M5 4h13l-2.5 4L18 12H5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
    </symbol>
  )],
  ["i-menu", (
    <symbol key="i-menu" id="i-menu" viewBox="0 0 24 24">
    <path d="M4 6h16M4 12h16M4 18h16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </symbol>
  )],
  ["i-chat", (
    <symbol key="i-chat" id="i-chat" viewBox="0 0 24 24">
    <path d="M4 5h16v11H9l-5 4V5z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    </symbol>
  )],
  ["s-down", (
    <symbol key="s-down" id="s-down" viewBox="0 0 120 36">
    <polyline points="2,8 18,10 32,9 46,15 60,14 74,20 88,19 102,26 118,30" fill="none" stroke="#0469f0" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="118" cy="30" r="3" fill="#0469f0" />
    </symbol>
  )],
  ["s-down2", (
    <symbol key="s-down2" id="s-down2" viewBox="0 0 120 36">
    <polyline points="2,6 18,12 32,10 46,11 60,18 74,17 88,24 102,23 118,29" fill="none" stroke="#0469f0" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="118" cy="29" r="3" fill="#0469f0" />
    </symbol>
  )],
  ["s-down3", (
    <symbol key="s-down3" id="s-down3" viewBox="0 0 120 36">
    <polyline points="2,10 18,9 32,14 46,13 60,12 74,19 88,25 102,24 118,31" fill="none" stroke="#0469f0" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="118" cy="31" r="3" fill="#0469f0" />
    </symbol>
  )],
]

/** The sprite. With `only`, just those symbols — a page that uses four of the 34 must not ship all 34 twice (HTML + RSC payload). */
export function HomeSprite({ only }: { only?: readonly SpriteId[] } = {}) {
  const symbols = only ? SPRITE_SYMBOLS.filter(([id]) => only.includes(id)) : SPRITE_SYMBOLS
  return (
    <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
      <defs>
        {symbols.map(([id, node]) => (
          <Fragment key={id}>{node}</Fragment>
        ))}
      </defs>
    </svg>
  )
}

export function Icon({ id, className = 'i', style }: { id: SpriteId; className?: string; style?: CSSProperties }) {
  return (
    <svg className={className} style={style} aria-hidden="true">
      <use href={`#${id}`} />
    </svg>
  )
}
